import React from 'react';
import FacebookIcon from '../../assets/icons/facebook.svg';
import InstagramIcon from '../../assets/icons/instagram.svg';
import PinterestIcon from '../../assets/icons/pinterest.svg';
import TwitterIcon from '../../assets/icons/twitter.svg';
import classes from './SocialNetworks.css';

const SocialNetworks = props => {
    return (
        <ul className={classes.SocialNetworksList}>
            <li>
                <a href="https://twitter.com/BSantosOficial" target="_new">
                    <img src={TwitterIcon} alt="" />
                </a>
            </li>
            <li>
                <a
                    href="https://www.facebook.com/benito.santos.35"
                    target="_new"
                >
                    <img src={FacebookIcon} alt="" />
                </a>
            </li>
            <li>
                <a
                    href="https://www.instagram.com/benitosantosoficial/"
                    target="_new"
                >
                    <img src={InstagramIcon} alt="" />
                </a>
            </li>
            <li>
                <a
                    href="https://www.pinterest.com.mx/benitosantos/"
                    target="_new"
                >
                    <img src={PinterestIcon} alt="" />
                </a>
            </li>
        </ul>
    );
};

export default SocialNetworks;



// WEBPACK FOOTER //
// ./src/components/SocialNetworks/SocialNetworks.js